import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import useCustomToast from 'src/hooks/useCustomToast';

import useLoading from 'src/hooks/useLoading';
import useQueryString from 'src/hooks/useQueryString';
import { setCotizacionConfig } from 'src/reducers/Cotizacion/cotizacion.actions';
import { POST } from 'src/services';
import { urlGetCotizacionById, } from 'src/services/urls';

const useCotizacion = () => {

  const [, setError] = useState(false);
  const { cotizacion }: any = useSelector<any>((state) => state.Cotizacion);
  const { setLoading, resetLoading, setSecundario } = useLoading();

  const dispatch = useDispatch();
  const params: any = useParams<any>();
  const qParams = useQueryString();
  const toasts = useCustomToast();


  const actualizar = async () => {

    if (true) {
      setLoading(true);
      setSecundario('Buscando información de la cotización...');

      const { id: idqp = '' } = qParams;
      const { idCotizacion = '' } = params;
      const id = idqp || idCotizacion;
      if (id) {
        const { error, ...data } = await POST(urlGetCotizacionById(id));
        if (error || !data.transaccion) {
          setError(true);
          return toasts.addErrorToast('HA OCURRIDO UN PROBLEMA.');
        }
        console.log("USE_COTIZACION", data)
        dispatch(setCotizacionConfig(data));
      }
      resetLoading();
    }
  };

  useEffect(() => {
    if (!cotizacion) actualizar();
  }, [])

  return { cotizacion, idCotizacion: cotizacion?.idCotizacion, actualizar };
};




export default useCotizacion;
